export default "__VITE_ASSET__zuswcnw7__"